import { SERVICE_BY_SLUG } from "./exterior-services";

/** Keyword → service matches, most specific first. Used to put the right estimate inside each article. */
const RULES: [RegExp, string][] = [
  [/roof|moss|lichen/i, "roof-cleaning"],
  [/gutter|downpipe/i, "gutter-cleaning"],
  [/fascia|soffit/i, "fascia-soffit-cleaning"],
  [/solar/i, "solar-panel-cleaning"],
  [/conservatory/i, "conservatory-cleaning"],
  [/deck|fence/i, "fence-decking-cleaning"],
  [/render|wall/i, "render-cleaning"],
  [/soft.?wash/i, "soft-washing"],
  [/driveway|block.?paving/i, "driveway-cleaning"],
  [/patio|slab|paving|porcelain/i, "patio-cleaning"],
  [/pressure|jet.?wash|sprayer|exterior cleaner/i, "pressure-washing"],
  [/window|glass/i, "window-cleaning"],
  [/graffiti/i, "graffiti-removal"],
  [/oven/i, "oven-cleaning"],
  [/end.?of.?tenancy|move.?out|deposit/i, "end-of-tenancy-cleaning"],
  [/move.?in/i, "move-in-cleaning"],
  [/kitchen/i, "kitchen-cleaning"],
  [/bathroom|shower|limescale/i, "bathroom-cleaning"],
  [/deep clean|spring clean/i, "deep-house-cleaning"],
  [/clean|reset|tidy/i, "regular-house-cleaning"],
];

export function serviceForArticle(text: string): string | null {
  for (const [re, slug] of RULES) if (re.test(text) && SERVICE_BY_SLUG.has(slug)) return slug;
  return null;
}
